import * as yup from 'yup'
import { trimString } from 'common/utils/yupSchemaUtils'

export const MAX_VIDEO_TITLE_LENGTH = 55
export const MAX_VIDEO_DESCRIPTION_LENGTH = 600

export const schema = yup
  .object({
    title: yup
      .string()
      .required('Video title required')
      .min(3, 'Video title must be at least 3 characters')
      .max(MAX_VIDEO_TITLE_LENGTH, 'Video title must be less than 56 characters')
      .transform(trimString),
    subtitle: yup.string().max(36, 'Subtitle must be under 36 characters'),
    description: yup.string().max(MAX_VIDEO_DESCRIPTION_LENGTH, 'Description must be under 600 characters'),
  })
  .required()
